import { Page, Text, View, Document, StyleSheet ,Font ,Image} from '@react-pdf/renderer';
import React from 'react'
import LatoRegular from '../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import Heart from "../../Assets/Images/HEART.png"
import Soul from "../../Assets/Images/SOUL.png"
import Mind from "../../Assets/Images/MIND.png"
import Strength from "../../Assets/Images/STRENGTH.png"
import Header from "./Header";
import Footer from "./Footer";

Font.register({
    family: 'Lato',
    fonts: [
      { src: LatoRegular, fontWeight: 400 },
      { src: LatoBold , fontWeight: 700 }
    ]
});

  const styles = StyleSheet.create({
      page: {
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'space-between',
        //   padding: 5,
        },
    content: {
        flexGrow: 1,
    },
    footer: {
        marginTop: 'auto',
    },
    headerBox: {
        display: 'flex',
        marginBottom: 10,
    },
    title: {
        fontSize: 18,
        fontWeight: 700,
        color: '#426B88',
        marginBottom: 10,
    },
    subTitle: {
        fontSize: 12,
        color: '#245775',
        marginBottom: 10,
        fontWeight:400,
    },
    table: {
        width: '100%',
        borderWidth: 1,
        borderColor: '#ccc',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#ccc',
        paddingVertical: 4,
        alignItems: 'center',
        borderLeftWidth: 1,
        borderLeftColor: '#ccc',
        borderRightWidth: 1,
        borderRightColor: '#ccc',
    },
      tableHeader: {
        fontWeight: 400,
        border:'0px',
        backgroundColor: '#426B88',
        fontWeight: 'bold',
        color: 'white',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      },
    headerCell:{color: 'white', fontWeight:400},
    cellIndex: { width: '5%', textAlign: 'center', fontSize: 10, color:"#394554"},
    cellQuadrant: { width: '13%', textAlign: 'left', fontSize: 10 ,color:"#394554"},
    cellLogo: { width: '5%', textAlign: 'center' },
    cellQuestion: { width: '70%', fontSize: 10, paddingHorizontal: 4 ,color:"#394554", fontWeight:400},
    cellScore: { width: '7%', textAlign: 'center', fontSize: 10 ,color:"#394554"},
    cell: {
        flex: 1,
        fontSize: 10,
        paddingHorizontal: 4,
      },
      logo: {
        width: 14.3,
        height: 14.3,
    },
  });


  const data = [
    { quadrant: 'HEART', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
    { quadrant: 'SOUL', question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 4 },
    { quadrant: 'MIND', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
    { quadrant: 'STRENGTH', question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 4 },
    { quadrant: 'HEART', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
    { quadrant: 'SOUL', question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 4 },
    { quadrant: 'MIND', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
    { quadrant: 'STRENGTH', question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 4 },
    { quadrant: 'HEART', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
    { quadrant: 'SOUL', question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 4 },
    { quadrant: 'MIND', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
    { quadrant: 'STRENGTH', question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 4 },
    { quadrant: 'HEART', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
    { quadrant: 'SOUL', question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 4 },
    { quadrant: 'MIND', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
    { quadrant: 'STRENGTH', question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 4 },
    { quadrant: 'HEART', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
    { quadrant: 'SOUL', question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 4 },
    { quadrant: 'MIND', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
    { quadrant: 'STRENGTH', question: 'My superpower is to rise above any situation to gain a wise perspective.', score: 4 },
    { quadrant: 'HEART', question: 'When presented with a problem, I am most concerned with how the team is handling it.', score: 4 },
];

const Logo = (quadrant) => {
    switch (quadrant) {
        case 'HEART':
            return <Image src={Heart} style={styles.logo} />;
        case 'SOUL':
            return <Image src={Soul} style={styles.logo} />;
        case 'MIND':
            return <Image src={Mind} style={styles.logo} />;
        case 'STRENGTH':
            return <Image src={Strength} style={styles.logo} />;
        default:
            return null;
    }
};
const truncateText = (text, limit) => {
    if (text.length <= limit) return text;
    return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const TableOfContents = () => (
    <View style={styles.page}>
    <Header/>
    
    <View style={styles.headerBox}>
        <Text style={styles.title}>QUADRANT FLOW ITEMS OVERVIEW</Text>
        <Text style={styles.subTitle}>
            This page presents a ranking of all 40 items distributed across the four quadrants: 
            Heart, Soul, Mind, and Strength™. The rankings are based on self-ratings provided by participants, 
            using a response scale that ranges from 1 (Least) to 4 (Most).
        </Text>
    </View>

    {/* Main Content Wrapper */}
    <View style={styles.content}>
        <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.cellIndex, styles.headerCell]}>#</Text>
            <Text style={[styles.cellQuadrant, styles.headerCell]}>Quadrant</Text>
            <Text style={[styles.cellLogo, styles.headerCell]}></Text>
            <Text style={[styles.cellQuestion, styles.headerCell]}>Question</Text>
            <Text style={[styles.cellScore, styles.headerCell]}>Score</Text>
        </View>
        
        {data.map((item, index) => (
            <View key={index} style={[
                styles.tableRow, 
                { backgroundColor: index % 2 === 0 ? '#F1F3F3' : '#FFF' }
            ]}>
                <Text style={styles.cellIndex}>{index +  1}</Text>
                <Text style={styles.cellQuadrant}>{item.quadrant}</Text>
                <View style={styles.cellLogo}>{Logo(item.quadrant)}</View>
                <Text style={styles.cellQuestion}>{truncateText(item.question, 80)}</Text>
                <Text style={styles.cellScore}>{item.score}</Text>
            </View>
        ))}
    </View>

    {/* Footer Sticks to Bottom */}
    <Footer/>
</View>

);

export default TableOfContents;